import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { resetBlock } from '../../ServiceAppointmentBlockSlice';
import { goToNextPageAsync } from '../../ServiceAppointmentAsyncthunk';
import Config from '../../../../../Config';



const RestartRouter = (props) => {
    const routerInfo = props.routerDisplay?.map((item) => {
        const desImage = item.desImage || null;
        const routerStartTime = item.routerStartTime;
        return {
            desImage,
            routerStartTime
        };
    });

    let time='';
    if('STRENGTH_PERFORMED_9_2'){
        time = props.lightTime;
    }else if('EXTENDING_ROUTER_TIME_8_1_3') {
        time= props.routerTimeExtension;
    }else if ('RESET_ROUTER_8_1_1') {
        time= routerInfo[0].routerStartTime;
    };

    const [remainingTime, setRemainingTime] = useState(time);

    useEffect(() => {
        let interval;
            interval = setInterval(() => {
                setRemainingTime((prevTime) => {
                    if (prevTime <= 0) {
                        clearInterval(interval);
                        props.goToNextPageAsync();
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        return () => clearInterval(interval);
    }, [props.typePage, props.goToNextPageAsync]);

    let title = null;
    let subTitle = null;
    let text = null;
    let imgUrl = '';

    switch (props.typePage) {
        case 'RESET_ROUTER_8_1_1':
            subTitle = <>הנתב מבצע הפעלה מחדש כעת</>;
            text = <>נותרו <span>{remainingTime}</span> שניות</>;
            break;
        case 'EXTENDING_ROUTER_TIME_8_1_3':
            title = <> מוודאים שוב שהנתב סיים את ההפעלה מחדש</>;
            imgUrl= props.imageLoader
            subTitle = <>הנתב מבצע הפעלה מחדש כעת</>;
            text = <>נותרו <span>{remainingTime}</span> שניות</>;
            break;
        case 'STRENGTH_PERFORMED_9_2':
            subTitle = <>מתבצעת בדיקת עוצמות</>;
            text = <>נותרו <span>{remainingTime}</span> שניות</>;
            break;
    }

    return (
        <div className='restart-router-page' data-error={props.errorDescription}>
            {title && <div className='title'>{title}</div>}
            {imgUrl && <Image src={ Config.epiBaseUrl + imgUrl} alt='image' />}
            {subTitle && <div className='sub-title'>{subTitle}</div>}
            {text && <div className='text'>{text}</div>}
        </div>
    );

};
const mapStateToProps = (state) => {
    return {
        imageLoader: state.serviceAppointmentSchedulerBlock.dataEpi.imageLoader.url,
        typePage: state.serviceAppointmentSchedulerBlock.typePage,
        routerDisplay: state.serviceAppointmentSchedulerBlock.routerDisplay,
        lightTime: state.serviceAppointmentSchedulerBlock.dataEpi.lightTime,
        routerTimeExtension: state.serviceAppointmentSchedulerBlock.dataEpi.routerTimeExtension,

    };
};

const mapDispatchToProps = { resetBlock, goToNextPageAsync };

export default connect(mapStateToProps, mapDispatchToProps)(RestartRouter);
